/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { userAdminControllerBlockV1 } from '../fn/user-admin/user-admin-controller-block-v-1';
import { UserAdminControllerBlockV1$Params } from '../fn/user-admin/user-admin-controller-block-v-1';
import { userAdminControllerDeleteV1 } from '../fn/user-admin/user-admin-controller-delete-v-1';
import { UserAdminControllerDeleteV1$Params } from '../fn/user-admin/user-admin-controller-delete-v-1';
import { userAdminControllerFindAllV1 } from '../fn/user-admin/user-admin-controller-find-all-v-1';
import { UserAdminControllerFindAllV1$Params } from '../fn/user-admin/user-admin-controller-find-all-v-1';
import { userAdminControllerFindByIdV1 } from '../fn/user-admin/user-admin-controller-find-by-id-v-1';
import { UserAdminControllerFindByIdV1$Params } from '../fn/user-admin/user-admin-controller-find-by-id-v-1';
import { userAdminControllerSearchCursorV1 } from '../fn/user-admin/user-admin-controller-search-cursor-v-1';
import { UserAdminControllerSearchCursorV1$Params } from '../fn/user-admin/user-admin-controller-search-cursor-v-1';
import { userAdminControllerSearchOffsetV1 } from '../fn/user-admin/user-admin-controller-search-offset-v-1';
import { UserAdminControllerSearchOffsetV1$Params } from '../fn/user-admin/user-admin-controller-search-offset-v-1';
import { userAdminControllerUnblockV1 } from '../fn/user-admin/user-admin-controller-unblock-v-1';
import { UserAdminControllerUnblockV1$Params } from '../fn/user-admin/user-admin-controller-unblock-v-1';
import { userAdminControllerUpdateV1 } from '../fn/user-admin/user-admin-controller-update-v-1';
import { UserAdminControllerUpdateV1$Params } from '../fn/user-admin/user-admin-controller-update-v-1';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class UserAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userAdminControllerFindAllV1()` */
  static readonly UserAdminControllerFindAllV1Path = '/api/v1/users/admin';

  /**
   * 사용자 전체 조회 (관리자).
   *
   * 전체 사용자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerFindAllV1$Response(params?: UserAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    const obs = userAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 전체 조회 (관리자).
   *
   * 전체 사용자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerFindAllV1(params?: UserAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<UserDto>> {
    const resp = this.userAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `userAdminControllerSearchOffsetV1()` */
  static readonly UserAdminControllerSearchOffsetV1Path = '/api/v1/users/admin/search/offset';

  /**
   * 사용자 오프셋 기반 조회 (관리자).
   *
   * 사용자를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerSearchOffsetV1$Response(params: UserAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = userAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 오프셋 기반 조회 (관리자).
   *
   * 사용자를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerSearchOffsetV1(params: UserAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.userAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<UserDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `userAdminControllerSearchCursorV1()` */
  static readonly UserAdminControllerSearchCursorV1Path = '/api/v1/users/admin/search/cursor';

  /**
   * 사용자 커서 기반 조회 (관리자).
   *
   * 사용자를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerSearchCursorV1$Response(params: UserAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = userAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 커서 기반 조회 (관리자).
   *
   * 사용자를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerSearchCursorV1(params: UserAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.userAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<UserDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `userAdminControllerFindByIdV1()` */
  static readonly UserAdminControllerFindByIdV1Path = '/api/v1/users/admin/{id}';

  /**
   * 사용자 ID 기반 조회 (관리자).
   *
   * 사용자를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerFindByIdV1$Response(params: UserAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 ID 기반 조회 (관리자).
   *
   * 사용자를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerFindByIdV1(params: UserAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userAdminControllerDeleteV1()` */
  static readonly UserAdminControllerDeleteV1Path = '/api/v1/users/admin/{id}';

  /**
   * 사용자 삭제 (관리자).
   *
   * 사용자를 삭제합니다. (Soft Delete)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerDeleteV1$Response(params: UserAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 삭제 (관리자).
   *
   * 사용자를 삭제합니다. (Soft Delete)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerDeleteV1(params: UserAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userAdminControllerUpdateV1()` */
  static readonly UserAdminControllerUpdateV1Path = '/api/v1/users/admin/{id}';

  /**
   * 회원 정보 수정 (관리자).
   *
   * 회원 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAdminControllerUpdateV1$Response(params: UserAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = userAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 회원 정보 수정 (관리자).
   *
   * 회원 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAdminControllerUpdateV1(params: UserAdminControllerUpdateV1$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.userAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userAdminControllerBlockV1()` */
  static readonly UserAdminControllerBlockV1Path = '/api/v1/users/admin/{id}/block';

  /**
   * 사용자 차단 (관리자).
   *
   * 사용자를 차단합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerBlockV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerBlockV1$Response(params: UserAdminControllerBlockV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userAdminControllerBlockV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 차단 (관리자).
   *
   * 사용자를 차단합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerBlockV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerBlockV1(params: UserAdminControllerBlockV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userAdminControllerBlockV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userAdminControllerUnblockV1()` */
  static readonly UserAdminControllerUnblockV1Path = '/api/v1/users/admin/{id}/unblock';

  /**
   * 사용자 차단 해제 (관리자).
   *
   * 사용자의 차단을 해제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAdminControllerUnblockV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerUnblockV1$Response(params: UserAdminControllerUnblockV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = userAdminControllerUnblockV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사용자 차단 해제 (관리자).
   *
   * 사용자의 차단을 해제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAdminControllerUnblockV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userAdminControllerUnblockV1(params: UserAdminControllerUnblockV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.userAdminControllerUnblockV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
